import api from "./api";

export const applicationService = {
  createApplication: (data) => api.post("/application/create", data),
  getApplicationList: (status) => api.get("/application/list", { params: { status } }),
  reviewApplication: (applicationId, data) => api.post(`/application/review/${applicationId}`, data),
  rejectApplication: (applicationId, data) => api.post(`/application/reject/${applicationId}`, data),
  schedulePanchanama: (applicationId, data) => api.post(`/application/schedule-panchanama/${applicationId}`, data),
  uploadPanchanama: (applicationId, formData) => api.post(`/application/upload-panchanama/${applicationId}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  }),
  scheduleAdvertisement: (applicationId, data) => api.post(`/application/schedule-advertisement/${applicationId}`, data),
  uploadAdvertisement: (applicationId, formData) => api.post(`/application/upload-advertisement/${applicationId}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  }),
  transferApplication: (applicationId, data) => api.post(`/application/transfer/${applicationId}`, data),
  verifyTreeDetails: (applicationId, data) => api.post(`/application/verify-tree/${applicationId}`, data),
  initiatePayment: (applicationId, data) => api.post(`/application/initiate-payment/${applicationId}`, data),
  approvePlantation: (applicationId, data) => api.post(`/application/approve-plantation/${applicationId}`, data),
  uploadPlantationVisit: (applicationId, formData) => api.post(`/application/upload-plantation/${applicationId}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  }),
  giveFinalPermission: (applicationId, data) => api.post(`/application/final-permission/${applicationId}`, data),
  uploadGeoImage: (applicationId, formData) => api.post(`/application/upload-geo/${applicationId}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  }),
};

